<template>
  <div class="layout">
    <headerCell></headerCell>
    <div class="wrap-content">
      <mp4Cell></mp4Cell>
      <bannerCell></bannerCell>
      <div class="content">
        <div class="text-wrap">
          <div class="tit">公司介绍</div>
          <div class="des">京融科技成立于2014年，是京赢集团的全资子公司。</div>
          <div class="des">公司致力于打造数字产业金融平台，通过大数据、区块链、人工智能等技术</div>
          <div class="des">链接金融与产业，为企业数字化转型赋能，为金融数字化转型赋能，是京赢集团“金融+科技+产业场景”战略布局的核心。</div>
        </div>
        <img src="../../assets/img/about/center-bg.png" alt="">
      </div>
    </div>
    <footerCell></footerCell>
  </div>
  </template>

  <script>
  import headerCell from '../../components/header/index';
  import footerCell from '../../components/footer/index';
  import bannerCell from './cell/banner.vue'
  import mp4Cell from './cell/mp4.vue'
  export default {
    name:'index_page',
    data(){
      return {

      }
    },
    components:{
      headerCell,
      footerCell,
      bannerCell,
      mp4Cell
    },
    methods:{

    },
    mounted() {
      this.$nextTick(() => {
      });
    }
  }
  </script>
  <style lang="less" scoped>
  .layout{
    width:100%;
    min-height: 100vh;
    overflow: hidden;
    .content{
      max-width: 1920px;
      margin:0 auto;
      padding:5vh 0 9vh 0;
      display:flex;
      align-items:center;
      justify-content:center;
      .text-wrap{
        padding-left: 50px;
        .tit{
          font-family: PingFang HK;
          font-style: normal;
          font-weight: 600;
          font-size: 40px;
          line-height: 56px;
          color: #3772FF;
          margin-bottom:20px;
        }
        .des{
          font-family: PingFang HK;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 40px;
          color: #222630;
        }
      }
      img{
        margin-left:50px;
        max-width: 500px;
      }
    }
  }
  </style>
